import { StepType } from "@redotech/redo-flows-core-schema-common/common";
import { PartialFlowStep } from "../steps";

/**
 * The End step a dropped rate replaces, if any. A rate is terminal, so the End
 * it displaces would be left floating with nothing pointing at it.
 */
export function replacedSuppliesEndStepId(
  steps: readonly PartialFlowStep[],
  newNodeType: StepType,
  idTo: string | undefined,
): string | undefined {
  if (!idTo || newNodeType !== StepType.SUPPLIES_SHIPPING_RATE) {
    return undefined;
  }
  const target = steps.find((step) => step.id === idTo);
  return target?.type === StepType.DO_NOTHING ? idTo : undefined;
}
